(function($){
    'use strict';

    $('.js-side-navigation-toggle').each(function() {
    	var $toggleButton = $(this),
    		$subNavigation = $toggleButton.closest('li').find('.js-side-navigation-list');

    	$toggleButton.closest('div').addClass('parent');

        if($subNavigation.children('li').length < 1){
            $toggleButton.addClass('disable-js');
        }

    	$toggleButton.click(function(event) {
            event.preventDefault();
            if(!$toggleButton.hasClass('disable-js')) {
                if($toggleButton.hasClass('active')) {
                   $toggleButton.removeClass('active');
                   $subNavigation.slideUp(300, function() {
                       $subNavigation.removeAttr('style').removeClass('active');
                   });
               } else {
                   $toggleButton.addClass('active');
                   $subNavigation.slideDown(300, function() {
                       $subNavigation.addClass('active').removeAttr('style');
                   });
               }
           } else {
               window.location.href = $(this).siblings('a').attr("href");
           }
	    });
    });

}(jQuery));
